﻿import * as c from '../helpers/constants'
import { getToken, isAuthenticated } from '../store/auth';

const constants = {
    NEW_LIST: 'NEW_LIST',

    UPLOAD_LIST_REQUEST: 'UPLOAD_LIST_REQUEST',
    UPLOAD_LIST_SUCCESS: 'UPLOAD_LIST_SUCCESS',
    UPLOAD_LIST_FAILURE: 'UPLOAD_LIST_FAILURE',

    IMPORT_LIST_REQUEST: 'IMPORT_LIST_REQUEST',
    IMPORT_LIST_SUCCESS: 'IMPORT_LIST_SUCCESS',
    IMPORT_LIST_FAILURE: 'IMPORT_LIST_FAILURE',

    FINISH: 'FINISH'
};

const initialState = {
    upload: undefined,
    mapear: undefined,

    exception: undefined,
    isSent: false,
    isFinished: false
};

export const listaAction = {

    novaLista: () => async(dispatch, getState) => {
        dispatch({ type: constants.NEW_LIST });
    },

    upload: (form) => async(dispatch, getState) => {
        if (!isAuthenticated()) throw (c.MESSAGE_ERROR(c.AUTH_ERROR));

        const _token = c.AUTH_HEADER(getToken());

        let data = new FormData();
        data.append('file', form.file);
        data.append('nomeListaContato', form.nomeListaContato);
        data.append('usuario', form.usuario);
        data.append('tipoLista', form.tipoListaContato);

        const url = `${ c.API_CAMPAIGN_URL }/uploadFileListContact`;        
        const options = {
            method: 'POST',            
            body: data,
            headers: {'Authorization': _token }
        };


        dispatch({ type: constants.UPLOAD_LIST_REQUEST });

        return await fetch(url, options).then(async(response) => {            

            if (response.ok) {  
                dispatch({ type: constants.UPLOAD_LIST_SUCCESS, form: form });       
            }

            let json = await response.json();        

            return json;

        }).catch((exception) => {
            dispatch({ type: constants.UPLOAD_LIST_FAILURE, exception: exception });
            throw (exception);
        });
    },

    importar: (form) => async(dispatch, getState) => {
        if (!isAuthenticated()) throw (c.MESSAGE_ERROR(c.AUTH_ERROR));

        const _token = c.AUTH_HEADER(getToken());

        const url = `${ c.API_CAMPAIGN_URL }/importContacts`;
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': _token
            },
            body: JSON.stringify({
                nome: form.responseUpload.nome,
                status: "Ativa",
                arquivo: form.responseUpload.arquivo,
                contatos: form.responseUpload.contatos,
                tags: form.tagSelecionadas,
                emailUsuario: form.emailUsuario,
                nomeLista: form.responseUpload.nomeLista,
                tipoListaContato: form.tipoListaContato
            })
        };

        dispatch({ type: constants.IMPORT_LIST_REQUEST });

        return await fetch(url, options).then(async (response) => {
            const text = await response.text();
            const json = text ? JSON.parse(text) : {};

            if (response.ok) {
                dispatch({ type: constants.IMPORT_LIST_SUCCESS, form: form, payload: json });
            } else {
                dispatch({ type: constants.IMPORT_LIST_FAILURE, exception: json });
            }

            return { ok: response.ok, data: json }; // <<<<<<
        }).catch((exception) => {
            dispatch({ type: constants.IMPORT_LIST_FAILURE, exception });
            throw exception;
        });
    },
    

    uploadValidacao: (form) => async(dispatch, getState) => {
        if (!isAuthenticated()) throw (c.MESSAGE_ERROR(c.AUTH_ERROR));

        const _token = c.AUTH_HEADER(getToken());

        const formData = new FormData();
        formData.append("arquivo", form.file);    
        formData.append("nomeArquivo", form.nomeListaContato);
        formData.append("idEmpresa", form.empresa.id);
        formData.append("idCentroCusto", form.centroCusto.id);
        formData.append("empresa", form.empresa.nome);
        formData.append("centroCusto", form.centroCusto.nome);
        
        let url = `${ c.VALIDACAO_EMAIL }/${form.email}/upload`;       
        const options = {
            method: 'POST',            
            body: formData,
            headers: { 'Authorization': _token }
        };


        dispatch({ type: constants.UPLOAD_LIST_REQUEST });

        return await fetch(url, options).then(async(response) => {            

            if (response.ok) {  
                return response;
            }

            let json = await response.json();        

            console.log(json)

            return json;

        }).catch((exception) => {
            throw (exception);
        });
    },

    finalizar: (form) => async(dispatch, getState) => {
        dispatch({ type: constants.FINISH });
    }
};

export const reducer = (state, action) => {

    state = state || initialState;

    switch (action.type) {
        case constants.NEW_LIST:
            return {
                upload: undefined,
                mapear: undefined,
                error: undefined,
                isFinished: false
            };

        case constants.UPLOAD_LIST_REQUEST:
            return {
                ...state,
                upload: {}
            };

        case constants.UPLOAD_LIST_SUCCESS:
            return {
                ...state,
                upload: { isSubmitted: true, form: action.form }
            };

        case constants.UPLOAD_LIST_FAILURE:
            return {
                ...state,
                upload: {},
                exception: action.exception,
            };

        case constants.IMPORT_LIST_REQUEST:
            return {
                ...state,
                mapear: {},
            };

        case constants.IMPORT_LIST_SUCCESS:
            return {
                ...state,
                mapear: { isSubmitted: true, form: action.form }
            };

        case constants.IMPORT_LIST_FAILURE:
            return {
                ...state,
                mapear: {},
                exception: action.exception,
            };

        case constants.FINISH:
            return {
                ...state,
                isFinished: true
            };

        default:
            return state;
    }
}